import { dataVolumeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVolumeSolid = /*#__PURE__*/createIcon(dataVolumeSolid)
export default IconVolumeSolid
